import DOMPurify from "dompurify";

export default () => {
  DOMPurify.setConfig({ ADD_ATTR: ["target"] });
};
